import React from "react";
import AllManageSiteUserAdvertiser from "../component/sections/user//manage/AllSiteUserAdvertiser";
import InfoSiteUserAdvertiser from "../component/sections/user/manage/InfoSiteUserAdvertiser";
import ManageAllSiteUserPublisher from "../component/sections/user/manage/AllSiteUserPublisher";
import middleware from "./middlewares/middleware";
import InfoSiteUserPublisher from "../component/sections/user/manage/InfoSiteUserPublisher";
import ListUsersAreRegisteredByMarketer from "../component/sections/user/manage/marketer/AllUserAreRegisteredByMarketer";
import AllNoteCall from "../component/sections/user/manage/note-call/All";
import AddNoteCall from "../component/sections/user/manage/note-call/Add";
import ViewNoteCall from "../component/sections/user/manage/note-call/View";
import EditNoteCall from "../component/sections/user/manage/note-call/Edit";

const userRoutes = [
  {
    path: "/user/manage/:userID/site-advertiser",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllManageSiteUserAdvertiser />,
        "AllManageSiteUserAdvertiser"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/:userID/site-publisher",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllSiteUserPublisher />,
        "ManageAllSiteUserPublisher"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/:userID/note-call",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllNoteCall />,
        "AllNoteCall"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/:userID/note-call/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddNoteCall />,
        "AddNoteCall"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/:userID/note-call/view/:noteCallID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewNoteCall />,
        "ViewNoteCall"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/:userID/note-call/edit/:noteCallID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditNoteCall />,
        "EditNoteCall"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/site-advertiser/:siteAdvertiserID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoSiteUserAdvertiser />,
        "InfoSiteUserAdvertiser"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/site-publisher/:sitePublisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoSiteUserPublisher />,
        "InfoSiteUserPublisher"
      );
    },
    exact: true,
  },
  {
    path: "/user/manage/marketer/list-users-are-registered-by-marketer/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ListUsersAreRegisteredByMarketer />,
        "ListUsersAreRegisteredByMarketer"
      );
    },
    exact: true,
  },
];

export default userRoutes;
